import { useEffect } from 'react';

import { Footer } from '@deere/fuel-react/Footer.js';
import Link from '@mui/material/Link';
import useDynamicScript from '../utils/UseDynamicScript.util';
import { getContactUsLink } from '../shared/UtilFunctions';
import { useUserInfo } from '../shared/UserInfo';
import { getEnvVar } from '../utils/getEnvVar';

export default function SMFooter() {
  const info = useUserInfo();
  const loggedInUser = info && info.userId;

  useEffect(() => {
    // Walkme
    if (
      window.location.hostname !== 'localhost' &&
      getEnvVar('VITE_WALKME_ENABLED') === 'true'
    ) {
      const walkme = document.createElement('script');

      walkme.type = 'text/javascript';
      walkme.defer = true;
      window._walkmeConfig = {
        smartLoad: true
      };
      walkme.src = getEnvVar('VITE_WALKME_URL');

      const s = document.getElementsByTagName('script')[0];

      if (s.parentNode) {
        s.parentNode.insertBefore(walkme, s);
      } else {
        document.body.appendChild(walkme);
      }
    }
  }, []);

  const adobeAnalyticsScript = useDynamicScript({
    url: 'https://assets.adobedtm.com/c271735be4ea/0aa12bb2f54f/launch-923c9c296726.min.js'
  });

  useEffect(() => {
    if (
      window.location.hostname !== 'localhost' &&
      adobeAnalyticsScript.ready
    ) {
      const element = document.createElement('script');

      element.type = 'text/javascript';
      element.innerHTML = '_satellite.pageBottom();';
      document.body.appendChild(element);
    }
  }, [adobeAnalyticsScript.ready]);

  return (
    <Footer>
      <Link href="https://jdsn.deere.com">Home</Link>
      <Link
        href="http://www.deere.com/suppliercode"
        target="_blank"
        rel="noopener noreferrer"
      >
        Supplier Code of Conduct
      </Link>
      <Link
        href="https://www.deere.com/en/privacy-and-data/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy &amp; Data
      </Link>
      <Link
        href="https://www.deere.com/en/privacy-and-data/terms/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </Link>
      <Link
        href={getContactUsLink(loggedInUser)}
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact Us
      </Link>
    </Footer>
  );
}
